import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";

import { SEND_PROFILE_DATA } from "../../Action/actionTypes";
import { notifyPromise } from "../../../Utils/Helper";
import { sendProfiledataFailure, sendProfiledataSuccess } from "../../Action";

function* sendProfileDataRequest(action) {
  try {
    const userId= action?.payload?.userId
    const { data } = yield notifyPromise(
      API.post(`/sendProfileData?userId=${userId}`, action?.payload?.payload),
      "Updating Profile..."
    );

    if (data?.code === 200) {
     
      yield put(sendProfiledataSuccess(data?.data));
      if (action?.payload?.callback) {
 
        yield call(action.payload.callback, data);
      }
    } else {
      yield put(sendProfiledataFailure());
    }
  } catch (error) {
    yield put(sendProfiledataFailure());
  }
}

export function* watchSendProfileDataAPI() {
  yield takeEvery(SEND_PROFILE_DATA, sendProfileDataRequest);
}

export default function* rootSaga() {
  yield all([watchSendProfileDataAPI()]);
}
